// @ts-nocheck
import { Plugin } from '/data1/jenkins/workspace/aplus_tiger_h5_game_details_share_page_202204251659490524a1d2-5835-4a76-a8b1-7acfca817b0e_tiger-platform_gamecenter_h5_game_details_share_page_20220425165949_48687_nodejs_prod/node_modules/@umijs/runtime';

const plugin = new Plugin({
  validKeys: ['modifyClientRenderOpts','patchRoutes','rootContainer','render','onRouteChange','__mfsu',],
});

export { plugin };
